/* eslint-disable */
import { JSEncrypt } from 'jsencrypt'
import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard/Dashboard.vue";
import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
import SendMessage from "../views/envios-masivos/Index.vue"

import perfil from "../views/Perfil.vue";
import NotFound from "../views/404.vue";
import keys from '@/store/keys';


import Terminos from "../views/Terminos.vue";
import Mas from "../views/Mas.vue";
import Password from "../views/Password.vue";

import Administracion from "../views/Administracion/Index.vue";
import Chat from "../views/Chat/Index.vue"



const routes = [
  {
    path: "/",
    name: "login",
    redirect: "/login",
    meta: { layout: 'full' }
  },
  {
    path: "/dashboard/mas",
    name: "mas",
    component: Mas,
    meta: { requiresAuth: true, layout: 'horizontal', breadCrumb: "Otras opciones" }
  },
  {
    path: "/dashboard/chat",
    name: "chat",
    component: Chat,
    meta: { requiresAuth: true, layout: 'horizontal', breadCrumb: "Chat" }
  },
  {
    path: "/dashboard/terminos",
    name: "terminos",
    component: Terminos,
    meta: { requiresAuth: true, layout: 'horizontal', breadCrumb: "Términos y condiciones" }
  },
  {
    path: "/dashboard/envios",
    name: "SendMessage",
    component: SendMessage,
    meta: {
      requiresAuth: true,
      rol: false,
      layout: 'horizontal',
      breadCrumb: "Envío de mensajes",
      requiredRole: ['Administrador', 'Secretaria', 'Normal'] //esto si funciona....
    }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, layout: 'horizontal', breadCrumb: "Inicio" }
  },
  {
    path: "/administracion",
    name: "Administracion",
    component: Administracion,
    meta: { requiresAuth: true, layout: 'horizontal', breadCrumb: "Administración" }
  },
  {
    path: "/login",
    name: "Signin",
    component: Signin,
    meta: { layout: 'full' }
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
    meta: { layout: 'full' }
  },
  {
    path: "/dashboard/editarPerfil",
    name: "editarPerfil",
    component: perfil,
    meta: { requiresAuth: true, layout: 'full' }
  },
  {
    path: "/dashboard/password",
    name: "password",
    component: Password,
    meta: { requiresAuth: true, layout: 'full' }
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound,
    meta: { layout: 'full' }
  }


];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});






router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    const userData = localStorage.getItem("userData");
    const user = userData;

    if (!user) {
      next('/login');
    } else {
      // Verificar si la ruta requiere un rol específico
      const requiredRole = to.meta.requiredRole;
      const session = localStorage.getItem('session');

      if (requiredRole && session) {
        const decrypt = new JSEncrypt();
        decrypt.setPrivateKey(keys.privateKeyBackoffice);
        const userRole = decrypt.decrypt(session);

        if (Array.isArray(requiredRole) && requiredRole.includes(userRole)) {
          next();
        } else {          
          next('/dashboard');
        }
      } else {
        next();
      }
    }
  } else {
    next();
  }
});






router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;